@if (userActivated) {
    <h5 class="title-h5 text-center mb-6">{{ "public_activation_title" | translate }}</h5>
    <div class="text-center">
        <p>
            <span [innerHTML]="'public_activation_accountactivated2' | translate"></span>
        </p>
        <button pButton class="body-button p-button-blue-logo mt-6" type="button" (click)="goToLogin()">
            {{ "public_activation_buttonlogin" | translate }}
        </button>
    </div>
}

@if (tokenExpired) {
    <h5 class="title-h5 text-center mb-6">{{ "public_activation_expired_title" | translate }}</h5>
    <div class="text-center">
        <p>{{ "public_activation_token_outdated" | translate }}</p>
        <button pButton class="body-button p-button-blue-logo mt-6 text-nowrap w-auto!" type="button" (click)="resendCode()">
            {{ "public_activation_buttonresend" | translate }}
        </button>
    </div>
}
@if (codeResent) {
    <div class="mt-8 flex justify-center">
        <p-message severity="success">{{ "public_activation_tokensent" | translate }}</p-message>
    </div>
}
